import { render, staticRenderFns } from "./MicrolearningVideoWithGenerateInspectionBar.vue?vue&type=template&id=48e70f8c&scoped=true"
import script from "./MicrolearningVideoWithGenerateInspectionBar.vue?vue&type=script&setup=true&lang=js"
export * from "./MicrolearningVideoWithGenerateInspectionBar.vue?vue&type=script&setup=true&lang=js"
import style0 from "./MicrolearningVideoWithGenerateInspectionBar.vue?vue&type=style&index=0&id=48e70f8c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48e70f8c",
  null
  
)

export default component.exports